export const strings = {
  brand: 'Vam Law Group',
  brandUrl: 'https://www.vamlawgroup.com',
  errorToast: {
    default: {
      message:
        "Looks like we're having a little Internet turbulence, and that didn't go through.",
      buttonLabel: 'Try Again'
    },
    deadLock: {
      message:
        "Sorry, we're unable to process your request right now. Please try again later.",
      buttonLabel: 'VamLawGroup.com'
    }
  }
};
